'use strict';

DoohApps
.directive('ngIndeterminate', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            scope.$watch(attributes['ngIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
}]);